import {ApolloProvider} from "@apollo/react-hooks"
import {ActionSheetProvider} from "@expo/react-native-action-sheet"
import {SnackbarMessageProvider} from "@prosay/components"
import {translate} from "@prosay/i18n"
import {getLogger} from "@prosay/logging"
import React, {useEffect} from "react"
import {Platform, StyleSheet, Text, View} from "react-native"
import {
    ActivityIndicator,
    DefaultTheme,
    Provider as PaperProvider,
} from "react-native-paper"
import {client} from "./client"
import {AppScreen} from "./navigation"
import {useNotifications} from "./notifications"
import {
    ConversationSearchContainer,
    ConversationStatusContainer,
    TopicSearchContainer,
} from "./state"

const logger = getLogger(__filename)
const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
})

// TODO:  Add sentry
export interface AppProps {}
export const App: React.FC<AppProps> = () => {
    useEffect(() => {
        logger.info`Loaded translations and starting application...`
        if (Platform.OS === "web") {
            ;(async () =>
                void (
                    await import("@prosay/components")
                ).patchFlatListProps())()
        }
    }, [])

    const notificationsReady = useNotifications()
    if (!notificationsReady) {
        return <ActivityIndicator />
    }

    return (
        <View style={styles.container}>
            <React.Suspense fallback={<Text>{translate("ui.loading")}</Text>}>
                <ApolloProvider client={client}>
                    <PaperProvider
                        theme={{
                            ...DefaultTheme,
                            colors: {
                                ...DefaultTheme.colors,
                                primary: "rgb(0, 113, 212)",
                            },
                        }}>
                        <ActionSheetProvider>
                            <SnackbarMessageProvider>
                                <TopicSearchContainer.Provider>
                                    <ConversationStatusContainer.Provider>
                                        <ConversationSearchContainer.Provider>
                                            <AppScreen />
                                        </ConversationSearchContainer.Provider>
                                    </ConversationStatusContainer.Provider>
                                </TopicSearchContainer.Provider>
                            </SnackbarMessageProvider>
                        </ActionSheetProvider>
                    </PaperProvider>
                </ApolloProvider>
            </React.Suspense>
        </View>
    )
}
